module.exports = __webpack_public_path__ + "public/img/logo.7c72cb3d.png";